import React from 'react';
import CarouselBanner from '../components/home/CarouselBanner';
import Headline from '../components/home/Headline';
import SubHeadlines from '../components/home/SubHeadlines';

export default function Home() {
    return (
        <>
            <Headline />
            <CarouselBanner />
            <SubHeadlines />
        </>
    )
}
